import { render, staticRenderFns } from "./EditPatientDialogContainer.vue?vue&type=template&id=0b02012c&scoped=true&"
import script from "./EditPatientDialogContainer.vue?vue&type=script&lang=ts&"
export * from "./EditPatientDialogContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b02012c",
  null
  
)

export default component.exports